import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  AuthorizeModule,
  CertificateManagerModule,
  JobStatusModule,
  LogoutModule,
  PrivilegeModule,
  RpConfigModule,
  UserInfoModule,
  WSClientModule
} from '@inera/common';
import { ApiModule } from '../api/api.module';
import { MenuComponent } from './components/menu/menu.component';
import { NavigationComponent } from './components/navigation/navigation.component';
import { AdminSithsEidBaseComponent } from './views/admin-idp-data-aggregation-base/admin-siths-eid-base.component';
import { JobViewComponent } from './views/job-view/job-view.component';
import { KeyManagerViewComponent } from './views/key-manager-view/key-manager-view.component';
import { PrivilegesRulesComponent } from './views/privileges-view/privileges-rules/privileges-rules.component';
import { PrivilegesViewComponent } from './views/privileges-view/privileges-view.component';
import { PrivilegesWsClientsComponent } from './views/privileges-view/privileges-ws-clients/privileges-ws-clients.component';
import { RpConfigViewComponent } from './views/rp-config-view/rp-config-view.component';
import { TrustHoldersComponent, TrustsComponent, TrustsManagerComponent } from './views/trust-view';
import { UserInfoViewComponent } from './views/user-info-view/user-info-view.component';

@NgModule({
  declarations: [
    AdminSithsEidBaseComponent,
    NavigationComponent,
    TrustsManagerComponent,
    TrustsComponent,
    TrustHoldersComponent,
    KeyManagerViewComponent,
    MenuComponent,
    PrivilegesViewComponent,
    PrivilegesRulesComponent,
    PrivilegesWsClientsComponent,
    RpConfigViewComponent,
    UserInfoViewComponent,
    JobViewComponent
  ],
  imports: [
    CommonModule,
    AuthorizeModule,
    CertificateManagerModule,
    LogoutModule,
    PrivilegeModule,
    WSClientModule,
    RpConfigModule,
    UserInfoModule,
    JobStatusModule,
    ApiModule,
    RouterModule.forChild([
      {
        path: '',
        component: AdminSithsEidBaseComponent,
        children: [
          {
            path: 'trusts-manager',
            component: TrustsManagerComponent,
            children: [
              {
                path: 'trusts',
                component: TrustsComponent
              },
              {
                path: 'trust-holders',
                component: TrustHoldersComponent
              },
              {
                path: '**',
                redirectTo: 'trusts'
              }
            ]
          },
          {
            path: 'jobs',
            component: JobViewComponent
          },
          {
            path: 'keymanager',
            component: KeyManagerViewComponent
          },
          {
            path: 'privileges',
            component: PrivilegesViewComponent,
            children: [
              {
                path: 'rules',
                component: PrivilegesRulesComponent
              },
              {
                path: 'wsclients',
                component: PrivilegesWsClientsComponent
              },
              {
                path: '**',
                redirectTo: 'rules'
              }
            ]
          },
          {
            path: 'rp-information',
            component: RpConfigViewComponent
          },
          {
            path: 'user-information',
            component: UserInfoViewComponent
          },
          {
            path: '**',
            redirectTo: 'trusts-manager'
          }
        ]
      }
    ])
  ]
})
export class AdminSithsEidModule {}
